import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {inject, observer} from "mobx-react";
import VerticalSpace from "../../palette/VerticalSpace";

function Privacy(props) {

    const {SessionStore} = props

    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }

            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)

                    // Handle forward event

                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    SessionStore.onHandlePath(false)
                    SessionStore.onHandlePrivacy(true)
                    setTimeout(() => history.push('/create-account'), 10)
                }
            }
        })
    }, [locationKeys,])

    const onClickBack = () => {
        SessionStore.onHandlePath(false)
        SessionStore.onHandlePrivacy(true)
        setTimeout(() => history.push('/create-account'), 10)
    }


    return (
        <div style={{width: '70%', margin: 'auto'}}>
            <VerticalSpace space={30}/>
            <h2>Términos y condiciones de uso</h2>
            <VerticalSpace space={30}/>
            <h3>1. Acuerdo de términos</h3>
            <p>
                Estos Términos y Condiciones constituyen un acuerdo legalmente vinculante hecho entre usted, ya sea
                personalmente o en nombre de una entidad ("usted") y Kirei Sftware Factory KireiApps S.A.S ("IKU",
                "nosotros", "nos" o "nuestro"), con respecto a su acceso y uso del sitio web kireiapps.com, así como
                cualquier otro medio de comunicación, canal de medios, sitio web móvil o aplicación móvil relacionado,
                vinculado o conectado de alguna otra manera (colectivamente, el "Sitio"). Usted acepta que al acceder al
                Sitio, ha leído, comprendido y acepta regirse por todos estos Términos y condiciones de uso. SI NO DESEA
                ESTAR OBLIGADO POR ESTOS TÉRMINOS DE USO, SALGA DEL SITIO AHORA. SU REMEDIO EN CASO DE INSATISFACCIÓN
                CON ESTE SITIO, O CUALQUIER PRODUCTO, SERVICIO, CONTENIDO U OTRA INFORMACIÓN DISPONIBLE EN O A TRAVÉS DE
                ESTE SITIO, ES DEJAR DE UTILIZAR EL SITIO Y / O ESOS PRODUCTOS O SERVICIOS EN PARTICULAR. SU ACUERDO CON
                NOSOTROS CON RESPECTO AL CUMPLIMIENTO DE ESTOS TÉRMINOS DE USO SE ENTRARÁ EN VIGOR INMEDIATAMENTE
                DESPUÉS DE COMENZAR EL USO DE ESTE SITIO.
            </p>
            <p style={{marginTop: 10}}>
                Los términos y condiciones suplementarios o los documentos que pueden publicarse en el Sitio de vez en
                cuando se incorporan aquí expresamente como referencia. Nos reservamos el derecho, a nuestro exclusivo
                criterio, de realizar cambios o modificaciones a estos Términos y condiciones en cualquier momento y por
                cualquier motivo. Le avisaremos sobre cualquier cambio actualizando la fecha de “Última actualización”
                de estos Términos y Condiciones y usted renuncia a cualquier derecho a recibir un aviso específico de
                cada uno de dichos cambios. Es su responsabilidad revisar periódicamente estos Términos y condiciones
                para mantenerse informado de las actualizaciones. Usted estará sujeto a, y se considerará que ha sido
                informado y aceptado, los cambios en los Términos y Condiciones revisados por su uso continuado del
                Sitio después de la fecha de publicación de dichos Términos revisados.
            </p>
            <p style={{marginTop: 10}}>
                La información proporcionada en el Sitio no está destinada a ser distribuida ni utilizada por ninguna
                persona o entidad en ninguna jurisdicción o país donde dicha distribución o uso sea contrario a la ley o
                regulación o que nos someta a cualquier requisito de registro dentro de dicha jurisdicción o país. . En
                consecuencia, aquellas personas que eligen acceder al Sitio desde otros lugares lo hacen por su propia
                iniciativa y son los únicos responsables del cumplimiento de las leyes locales, si y en la medida en que
                las leyes locales sean aplicables. Todos los usuarios que sean menores de edad en la jurisdicción en la
                que residen (generalmente menores de 18 años) deben tener el permiso y ser supervisados directamente por
                sus padres o tutores para usar el Sitio. Si es menor de edad, debe hacer que sus padres o tutores lean y
                acepten estos Términos de uso antes de que usted utilice el Sitio. Tal como se utiliza en estos Términos
                de uso, las referencias a nuestros "Afiliados" incluyen a nuestros propietarios, subsidiarias, compañías
                afiliadas, funcionarios, directores, proveedores, socios, patrocinadores y anunciantes, e incluye (sin
                limitación) a todas las partes involucradas en la creación, producción, y / o entregar este sitio y / o
                su contenido.
            </p>
            <h3 style={{marginTop: 10}}>2. Descripción de los servicios</h3>

            <p style={{marginTop: 10}}>
                Ponemos a disposición varios servicios en el Sitio, incluido, entre otros, un sistema de reserva de
                taxis que conecta a los pasajeros y las empresas de transporte o conductores, y otros servicios
                similares. IKU no proporciona por sí mismo servicios de transporte. Actuamos como intermediarios entre
                usted y las empresas de transporte y los conductores que brindan los servicios de transporte. Como tal,
                IKU no es parte de ningún contrato para la prestación de servicios de transporte y no acepta
                responsabilidad por las acciones o inacciones de las empresas de transporte individuales y los
                conductores que proporcionan los servicios de transporte. Al utilizar el Sitio para realizar una reserva
                u otras compras, usted realiza una transacción con un tercero, incluidas, entre otras, las empresas de
                transporte, y no asumimos responsabilidad alguna en relación con dichas compras, que son exclusivamente
                entre usted y el tercero correspondiente. Usted acepta y reconoce que nos eximirá de toda
                responsabilidad por las pérdidas sufridas por usted o el daño que le haya causado en relación con su
                compra de dichas transacciones, compras o servicios, y que cualquier reclamo relacionado con terceros es
                un asunto exclusivo entre usted y el tercero. partido. La empresa de transporte y el conductor que le
                brindan el servicio de transporte son los únicos responsables de atender y, cuando corresponda, resolver
                todas las quejas, cargos y recargos en disputa, incluidos los reclamos de sobrecargos, ajustes y
                demandas realizados por usted con respecto al servicio de transporte. IKU no administra ni es
                responsable de ninguna política de reembolso, política de cancelación u otros términos de compra de la
                empresa de transporte que le brinda el servicio de transporte. Usted es responsable de proporcionar, a
                su cargo, todo el equipo necesario para utilizar los servicios, incluida una computadora, un módem y
                acceso a Internet (incluido el pago de todas las tarifas asociadas con dicho acceso).
            </p>
            <p style={{marginTop: 10}}>
                Nos reservamos el derecho exclusivo de modificar o descontinuar el Sitio, incluida cualquiera de las
                características del Sitio, en cualquier momento con o sin previo aviso. No seremos responsables ante
                usted ni ante ningún tercero si ejercemos tal derecho. Cualquier característica nueva que aumente o
                mejore los servicios vigentes en ese momento en este Sitio también estará sujeta a estos Términos de uso
            </p>

            <h3 style={{marginTop: 10}}>3. Derechos de propiedad intelectual</h3>

            <p style={{marginTop: 10}}>
                Al utilizar el Sitio, usted declara y garantiza que: (1) toda la información de registro que envíe será
                verdadera, precisa, actual y completa; (2) mantendrá la precisión de dicha información y actualizará de
                inmediato dicha información de registro según sea necesario; (3) tiene la capacidad legal y acepta
                cumplir con estos Términos de uso; (4) no es menor de edad en la jurisdicción en la que reside, o si es
                menor, ha recibido permiso de los padres para utilizar el Sitio; (5) no accederá al Sitio a través de
                medios automatizados o no humanos, ya sea a través de un bot, script o de otro modo; (6) no utilizará el
                Sitio para ningún propósito ilegal o no autorizado; y (7) su uso del Sitio no violará ninguna ley o
                reglamento aplicable.
            </p>
            <p style={{marginTop: 10}}>
                Si proporciona información falsa, inexacta, no actual o incompleta, tenemos el derecho de suspender o
                cancelar su cuenta y rechazar cualquier uso actual o futuro del Sitio (o cualquier parte del mismo). Nos
                concede el derecho a divulgar a terceros determinados datos de registro sobre usted. La información que
                obtenemos a través de su uso de este sitio, incluidos sus Datos de registro, está sujeta a nuestra
                Política de privacidad, que se incorpora específicamente por referencia en estos Términos de uso.
            </p>

            <h3 style={{marginTop: 10}}>4. Registro de usuario</h3>

            <p style={{marginTop: 10}}>
                Es posible que deba registrarse en el Sitio. Usted acepta mantener la confidencialidad de su contraseña
                y será responsable de todo uso de su cuenta y contraseña. Nos reservamos el derecho de eliminar,
                reclamar o cambiar un nombre de usuario que seleccione si determinamos, a nuestro exclusivo criterio,
                que dicho nombre de usuario es inapropiado, obsceno o de cualquier otra forma objetable.
            </p>

            <h3 style={{marginTop: 10}}>5. Actividades prohibidas</h3>

            <p style={{marginTop: 10}}>
                No puede acceder ni utilizar el Sitio para ningún otro propósito que no sea el que lo ponemos a
                disposición. El Sitio no se puede utilizar en relación con ningún esfuerzo comercial, excepto aquellos
                que son específicamente respaldados o aprobados por nosotros. Como usuario del Sitio, acepta no:
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                1. Recuperar sistemáticamente datos u otro contenido del Sitio para crear o compilar, directa o
                indirectamente, una colección, compilación, base de datos o directorio sin nuestro permiso por escrito.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                2. Hacer cualquier uso no autorizado del Sitio, incluida la recopilación de nombres de usuario y / o
                direcciones de correo electrónico de los usuarios por medios electrónicos o de otro tipo con el fin de
                enviar correos electrónicos no solicitados, o crear cuentas de usuario por medios automatizados o con
                falsas pretensiones.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                3. Utilizar el Sitio para publicitar u ofrecer vender bienes y servicios.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                4. Eludir, deshabilitar o interferir de cualquier otra manera con las funciones del Sitio relacionadas
                con la seguridad, incluidas las funciones que impiden o restringen el uso o la copia de cualquier
                Contenido o imponen limitaciones en el uso del Sitio y / o el Contenido incluido en el mismo.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                5. Participar en encuadres no autorizados o enlaces al Sitio.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                6. Engañarnos, defraudarnos o engañarnos a nosotros y a otros usuarios, especialmente en cualquier
                intento de obtener información confidencial de la cuenta, como las contraseñas de los usuarios.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                7. Hacer un uso indebido de nuestros servicios de soporte o enviar informes falsos de abuso o mala
                conducta.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                8. Participar en cualquier uso automatizado del sistema, como el uso de scripts para enviar comentarios
                o mensajes, o el uso de minería de datos, robots o herramientas similares de recopilación y extracción
                de datos.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                9. Intentar hacerse pasar por otro usuario o persona o utilizar el nombre de usuario de otro usuario.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                10. Vender o transferir su perfil.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                11. Utilizar cualquier información obtenida del Sitio para acosar, abusar o dañar a otra persona.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                12. Usar el Sitio como parte de cualquier esfuerzo para competir con nosotros o usar el Sitio y / o el
                Contenido para cualquier esfuerzo de generación de ingresos o empresa comercial.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                13. Descifrar, descompilar, desensamblar o aplicar ingeniería inversa a cualquier software que comprenda
                o de alguna manera forme parte del Sitio.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                14. Intentar eludir cualquier medida del Sitio diseñada para prevenir o restringir el acceso al Sitio, o
                cualquier parte del Sitio.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                15. Acosar, molestar, intimidar o amenazar a cualquiera de nuestros empleados o agentes que le
                proporcionen cualquier parte del Sitio.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                16. Eliminar el aviso de derechos de autor u otros derechos de propiedad de cualquier Contenido.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                17. Copiar o adaptar el software del Sitio, incluidos, entre otros, Flash, PHP, HTML, JavaScript, Python
                u otro código.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                18. Cargar o transmitir (o intentar cargar o transmitir) cualquier material que actúe como un mecanismo
                de transmisión o recopilación de información pasiva o activa, incluidos, entre otros, formatos de
                intercambio de gráficos claros ("gifs"), píxeles 1 × 1, errores web, cookies , u otros dispositivos
                similares (a veces denominados "software espía" o "mecanismos de recopilación pasiva" o "pcms").
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                19. Excepto que pueda ser el resultado del uso, uso, lanzamiento, desarrollo o distribución de un motor
                de búsqueda estándar o navegador de Internet, uso, lanzamiento, desarrollo o distribución de cualquier
                sistema automatizado, incluidos, entre otros, cualquier araña, robot, utilidad de trampa, raspador o
                lector fuera de línea que acceda al Sitio, o usar o ejecutar cualquier script u otro software no
                autorizado.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                20. Menospreciar, empañar o dañar de otra manera, en nuestra opinión, a nosotros y / o al Sitio.
            </p>
            <p style={{marginTop: 5, marginLeft: 20}}>
                21. Utilizar el Sitio de una manera incompatible con las leyes o reglamentaciones aplicables.
            </p>

            <h3 style={{marginTop: 10}}>6. Directrices para las evaluaciones</h3>

            <p style={{marginTop: 10}}>
                Podemos proporcionarle áreas en el Sitio para dejar comentarios o calificaciones. Al publicar una
                reseña, debe cumplir con los siguientes criterios: (1) debe tener experiencia de primera mano con la
                persona / entidad que está siendo revisada; (2) sus reseñas no deben contener blasfemias ofensivas o
                lenguaje abusivo, racista, ofensivo o de odio; (3) sus reseñas no deben contener referencias
                discriminatorias por motivos de religión, raza, género, nacionalidad, edad, estado civil, orientación
                sexual o discapacidad; (4) sus reseñas no deben contener referencias a actividades ilegales; (5) no debe
                estar afiliado a la competencia si publica críticas negativas; (6) no debe sacar ninguna conclusión
                sobre la legalidad de la conducta; (7) no puede publicar declaraciones falsas o engañosas; y (8) no
                puede organizar una campaña para animar a otros a publicar reseñas, ya sean positivas o negativas.
            </p>
            <p style={{marginTop: 10}}>
                Podemos aceptar, rechazar o eliminar reseñas a nuestro exclusivo criterio. No tenemos absolutamente
                ninguna obligación de filtrar reseñas o eliminar reseñas, incluso si alguien considera que las reseñas
                son objetables o inexactas. Las reseñas no están respaldadas por nosotros y no representan
                necesariamente nuestras opiniones o los puntos de vista de ninguno de nuestros afiliados o socios. No
                asumimos responsabilidad por ninguna revisión o por cualquier reclamo, responsabilidad o pérdida que
                resulte de cualquier revisión. Al publicar una reseña, por la presente nos otorga un derecho y una
                licencia perpetuos, no exclusivos, mundiales, libres de regalías, totalmente pagados, asignables y
                sublicenciables para reproducir, modificar, traducir, transmitir por cualquier medio, mostrar, realizar,
                y / o distribuir todo el contenido relacionado con las reseñas.
            </p>

            <h3 style={{marginTop: 10}}>7. Licencia de uso de aplicaciones móviles</h3>

            <p style={{marginTop: 10}}>
                Si accede al Sitio a través de una aplicación móvil, le otorgamos un derecho revocable, no exclusivo,
                intransferible y limitado para instalar y utilizar la aplicación móvil en dispositivos electrónicos
                inalámbricos de su propiedad o controlados por usted, y para acceder y utilizar el aplicación móvil en
                dichos dispositivos estrictamente de acuerdo con los términos y condiciones de esta licencia de
                aplicación móvil contenida en estos Términos de uso. Usted no deberá: (1) descompilar, realizar
                ingeniería inversa, desensamblar, intentar derivar el código fuente o descifrar la aplicación; (2)
                realizar cualquier modificación, adaptación, mejora, mejora, traducción o trabajo derivado de la
                aplicación; (3) violar las leyes, reglas o regulaciones aplicables en relación con su acceso o uso de la
                aplicación; (4) eliminar, alterar u ocultar cualquier aviso de propiedad (incluido cualquier aviso de
                derechos de autor o marca comercial) publicado por nosotros o los licenciantes de la aplicación; (5)
                utilizar la aplicación para cualquier actividad generadora de ingresos, empresa comercial u otro
                propósito para el cual no está diseñada o destinada; (6) hacer que la aplicación esté disponible a
                través de una red u otro entorno que permita el acceso o uso de múltiples dispositivos o usuarios al
                mismo tiempo; (7) usar la aplicación para crear un producto, servicio o software que sea, directa o
                indirectamente, competitivo con o de alguna manera un sustituto de la aplicación; (8) utilizar la
                aplicación para enviar consultas automatizadas a cualquier sitio web o para enviar cualquier correo
                electrónico comercial no solicitado; o (9) utilizar cualquier información patentada o cualquiera de
                nuestras interfaces o nuestra otra propiedad intelectual en el diseño, desarrollo, fabricación,
                concesión de licencias o distribución de cualquier aplicación, accesorio o dispositivo para su uso con
                la aplicación.
            </p>

            <h3 style={{marginTop: 10}}>8. Dispositivos Apple y Android</h3>

            <p style={{marginTop: 10}}>
                Los siguientes términos se aplican cuando utiliza una aplicación móvil obtenida de Apple Store o Google
                Play (cada uno es un "Distribuidor de aplicaciones") para acceder al Sitio: (1) la licencia que se le
                otorga para nuestra aplicación móvil se limita a una licencia transferible para usar la aplicación en un
                dispositivo que utiliza los sistemas operativos Apple iOS o Android, según corresponda, y de acuerdo con
                las reglas de uso establecidas en los términos de servicio aplicables del Distribuidor de la Aplicación;
                (2) somos responsables de proporcionar cualquier servicio de mantenimiento y soporte con respecto a la
                aplicación móvil según se especifica en los términos y condiciones de esta licencia de aplicación móvil
                contenida en estos Términos de uso o según lo requiera la ley aplicable, y usted reconoce que cada App
                Distributor no tiene obligación alguna de proporcionar ningún servicio de mantenimiento y soporte con
                respecto a la aplicación móvil; (3) en el caso de que la aplicación móvil no cumpla con cualquier
                garantía aplicable, puede notificar al Distribuidor de la aplicación correspondiente, y el Distribuidor
                de la aplicación, de acuerdo con sus términos y políticas, puede reembolsar el precio de compra , si lo
                hubiera, pagado por la aplicación móvil, y en la medida máxima permitida por la ley aplicable, el
                Distribuidor de la Aplicación no tendrá ninguna otra obligación de garantía con respecto a la aplicación
                móvil; (4) debe cumplir con los términos del acuerdo de terceros aplicables al usar la aplicación móvil,
                por ejemplo, si tiene una aplicación de VoIP, entonces no debe violar su acuerdo de servicio de datos
                inalámbricos al usar la aplicación móvil; y (7) usted reconoce y acepta que los Distribuidores de
                aplicaciones son terceros beneficiarios de los términos y condiciones de esta licencia de aplicación
                móvil contenida en estos Términos de uso, y que cada Distribuidor de aplicaciones tendrá el derecho (y
                se considerará que tiene aceptado el derecho) para hacer cumplir los términos y condiciones de esta
                licencia de aplicación móvil contenida en estos Términos de uso en su contra como un tercero
                beneficiario de la misma.
            </p>

            <h3 style={{marginTop: 10}}>9. Redes sociales</h3>

            <p style={{marginTop: 10}}>
                Como parte de la funcionalidad del Sitio, puede vincular su cuenta con las cuentas en línea que tenga
                con proveedores de servicios de terceros (cada una de esas cuentas, una "Cuenta de terceros") al: (1)
                proporcionar su Cuenta de terceros información de inicio de sesión a través del Sitio; o (2) permitirnos
                acceder a su Cuenta de Terceros, según lo permitan los términos y condiciones aplicables que rigen su
                uso de cada Cuenta de Terceros. Usted declara y garantiza que tiene derecho a divulgarnos la información
                de inicio de sesión de su Cuenta de terceros y / o concedernos acceso a su Cuenta de terceros, sin que
                usted incumpla ninguno de los términos y condiciones que rigen el uso de los Cuenta de terceros, y sin
                obligarnos a pagar ninguna tarifa o hacernos sujetos a las limitaciones de uso impuestas por el
                proveedor de servicios de terceros de la Cuenta de terceros. Al otorgarnos acceso a cualquier Cuenta de
                terceros, usted comprende que (1) podemos acceder, poner a disposición y almacenar (si corresponde)
                cualquier contenido que haya proporcionado y almacenado en su Cuenta de terceros (la "Red social
                Contenido ”) para que esté disponible en y a través del Sitio a través de su cuenta, y (2) podemos
                enviar y recibir información adicional de su Cuenta de Tercero en la medida en que se le notifique
                cuando vincule su cuenta con el Tercero. Cuenta de fiesta. Dependiendo de las Cuentas de terceros que
                elija y sujeto a la configuración de privacidad que haya establecido en dichas Cuentas de terceros, la
                información de identificación personal que publique en sus Cuentas de terceros puede estar disponible en
                y a través de su cuenta en el Sitio. Tenga en cuenta que si una Cuenta de terceros o un servicio
                asociado deja de estar disponible o nuestro acceso a dicha Cuenta de terceros es cancelado por el
                proveedor de servicios de terceros, es posible que el Contenido de la red social ya no esté disponible
                en y a través del Sitio. Tendrá la posibilidad de desactivar la conexión entre su cuenta en el Sitio y
                sus Cuentas de terceros en cualquier momento. TENGA EN CUENTA QUE SU RELACIÓN CON LOS PROVEEDORES DE
                SERVICIOS DE TERCEROS ASOCIADOS CON SUS CUENTAS DE TERCEROS SE RIGE ÚNICAMENTE POR SU ACUERDO (S) CON
                DICHOS PROVEEDORES DE SERVICIOS DE TERCEROS. No hacemos ningún esfuerzo por revisar ningún Contenido de
                la red social para ningún propósito, incluidos, entre otros, la precisión, legalidad o no infracción, y
                no somos responsables de ningún Contenido de la red social.
                Puede desactivar la conexión entre el Sitio y su Cuenta de terceros a través de la configuración de su
                cuenta en su Cuenta de terceros.
            </p>

            <h3 style={{marginTop: 10}}>10. Presentaciones</h3>

            <p style={{marginTop: 10}}>
                Usted reconoce y acepta que cualquier pregunta, comentario, sugerencia, idea, retroalimentación u otra
                información con respecto al Sitio ("Envíos") que nos proporcione no es confidencial y se convertirá en
                nuestra única propiedad. Seremos dueños de los derechos exclusivos, incluidos todos los derechos de
                propiedad intelectual, y tendremos derecho al uso y difusión sin restricciones de estos Envíos para
                cualquier propósito legal, comercial o de otro tipo, sin reconocimiento o compensación para usted. Por
                la presente renuncia a todos los derechos morales sobre dichos Envíos, y por la presente garantiza que
                dichos Envíos son originales de usted o que tiene derecho a enviar dichos Envíos. Usted acepta que no
                habrá ningún recurso contra nosotros por cualquier infracción o apropiación indebida presunta o real de
                cualquier derecho de propiedad en sus Envíos
            </p>

            <h3 style={{marginTop: 10}}>11. Sitios web y contenido de terceros</h3>

            <p style={{marginTop: 10}}>
                El Sitio puede contener (o puede ser enviado a través del Sitio) enlaces a otros sitios web ("Sitios web
                de terceros"), así como artículos, fotografías, texto, gráficos, imágenes, diseños, música, sonido,
                video, información, aplicaciones. , software y otro contenido o elementos que pertenezcan o se originen
                en terceros ("Contenido de terceros"). Dichos Sitios web de terceros y Contenido de terceros no son
                investigados, monitoreados ni verificados para su precisión, idoneidad o integridad, y no somos
                responsables de los Sitios web de terceros a los que se acceda a través del Sitio o de cualquier
                Contenido de terceros publicado. en, disponible a través o instalado desde el Sitio, incluido el
                contenido, la precisión, el carácter ofensivo, las opiniones, la confiabilidad, las prácticas de
                privacidad u otras políticas de o contenidas en los Sitios web de terceros o el Contenido de terceros.
                La inclusión, la vinculación o el permitir el uso o la instalación de cualquier sitio web de terceros o
                cualquier contenido de terceros no implica la aprobación o aprobación de los mismos por nuestra parte.
                Si decide abandonar el Sitio y acceder a los Sitios web de terceros o utilizar o instalar Contenido de
                terceros, lo hace bajo su propio riesgo y debe tener en cuenta que estos Términos de uso ya no rigen.
                Debe revisar los términos y políticas aplicables, incluidas las prácticas de privacidad y recopilación
                de datos, de cualquier sitio web al que navegue desde el Sitio o en relación con cualquier aplicación
                que use o instale desde el Sitio. Cualquier compra que realice a través de sitios web de terceros se
                realizará a través de otros sitios web y de otras empresas, y no asumimos responsabilidad alguna en
                relación con dichas compras, que son exclusivamente entre usted y el tercero correspondiente. Usted
                acepta y reconoce que no respaldamos los productos o servicios ofrecidos en los sitios web de terceros y
                nos eximirá de cualquier daño causado por la compra de dichos productos o servicios. Además, nos eximirá
                de toda responsabilidad por las pérdidas sufridas por usted o los daños que le hayan causado en relación
                con, o que resulten de cualquier manera, de cualquier Contenido de terceros o cualquier contacto con
                Sitios web de terceros.
            </p>

            <h3 style={{marginTop: 10}}>12. Gestión del sitio</h3>

            <p style={{marginTop: 10}}>
                Nos reservamos el derecho, pero no la obligación, de: (1) monitorear el Sitio para detectar violaciones
                de estos Términos de uso; (2) emprender las acciones legales apropiadas contra cualquier persona que, a
                nuestra entera discreción, viole la ley o estos Términos de uso, incluyendo, sin limitación, la denuncia
                de dicho usuario a las autoridades encargadas de hacer cumplir la ley; (3) a nuestro exclusivo criterio
                y sin limitación, rechazar, restringir el acceso, limitar la disponibilidad o deshabilitar (en la medida
                en que sea técnicamente posible) cualquiera de sus Contribuciones o cualquier parte de las mismas; (4) a
                nuestro exclusivo criterio y sin limitación, aviso o responsabilidad, para eliminar del Sitio o
                deshabilitar todos los archivos y contenido que sean de tamaño excesivo o que sean de alguna manera una
                carga para nuestros sistemas; y (5) de otra manera administrar el Sitio de una manera diseñada para
                proteger nuestros derechos y propiedad y para facilitar el funcionamiento adecuado del Sitio.
            </p>

            <h3 style={{marginTop: 10}}>13. Pagos con tarjeta</h3>

            <p style={{marginTop: 10}}>IKU ofrece un servicio en el que puede usar su tarjeta de crédito o débito para
                pagar los viajes a través de los llamados pagos integrados en la aplicación. IKU solo brinda la solución
                técnica para que usted pueda realizar las transacciones de pago al proveedor de transporte que realiza
                el servicio. IKU no participa en estas transacciones ni almacena ningún tipo de información referente a
                números de tarjeta o claves. Cualquier disputa o queja debe presentarse directamente con el proveedor de
                servicios de transporte. Al usar su tarjeta en el Sitio (en la aplicación o en la web), acepta que se le
                cobre automáticamente después de completar un viaje que haya reservado con la aplicación o en la web y
                especificó "tarjeta" como tipo de pago. También acepta que se le cobren las tarifas de cancelación y no
                presentación según lo estipulado por el proveedor de servicios de transporte en caso de que cancele su
                reserva o no se presente según lo acordado.
            </p>

            <h3 style={{marginTop: 10}}>14. Participación en promociones</h3>

            <p style={{marginTop: 10}}>
                De vez en cuando, este Sitio puede incluir anuncios ofrecidos por terceros. Puede mantener
                correspondencia o participar en promociones de los anunciantes que muestran sus productos en este sitio.
                Cualquier correspondencia o promociones, incluida la entrega y el pago de bienes y servicios, y
                cualquier otro término, condición, garantía o representación asociada con dicha correspondencia o
                promociones, son únicamente entre usted y el anunciante. No asumimos ninguna responsabilidad, obligación
                o responsabilidad por cualquier parte de dicha correspondencia o promoción.
            </p>

            <h3 style={{marginTop: 10}}>15. Seguridad y contraseña</h3>

            <p style={{marginTop: 10}}>
                Usted es el único responsable de mantener la confidencialidad de su contraseña y cuenta y de todas y
                cada una de las declaraciones hechas y actos u omisiones que ocurran a través del uso de su contraseña y
                cuenta. Por lo tanto, debe tomar medidas para asegurarse de que otros no obtengan acceso a su contraseña
                y cuenta. Nuestro personal nunca le pedirá su contraseña. No puede transferir ni compartir su cuenta con
                nadie, y nos reservamos el derecho de cancelar su cuenta inmediatamente si transfiere o comparte su
                cuenta.
            </p>

            <h3 style={{marginTop: 10}}>16. Política de privacidad</h3>

            <p style={{marginTop: 10}}>
                Nos preocupamos por la privacidad y seguridad de los datos, los cuales no son compartidos con terceros.
                Por favor revise nuestra Política de privacidad Política de privacidad de IKU . Al utilizar el Sitio,
                acepta estar sujeto a nuestra Política de privacidad, que se incorpora a estos Términos de uso.
            </p>

            <h3 style={{marginTop: 10}}>17. Duración y rescisión</h3>

            <p style={{marginTop: 10}}>
                Estos Términos de uso permanecerán en pleno vigor y efecto mientras utiliza el Sitio. SIN LIMITAR
                NINGUNA OTRA DISPOSICIÓN DE ESTOS TÉRMINOS DE USO, NOS RESERVAMOS EL DERECHO A, A NUESTRA ÚNICA
                DISCRECIÓN Y SIN PREVIO AVISO NI RESPONSABILIDAD, NEGAR EL ACCESO Y EL USO DEL SITIO (INCLUYENDO EL
                BLOQUEO DE CIERTAS DIRECCIONES IP), A CUALQUIER PERSONA POR CUALQUIER MOTIVO O SIN RAZÓN, INCLUYENDO SIN
                LIMITACIÓN POR INCUMPLIMIENTO DE CUALQUIER REPRESENTACIÓN, GARANTÍA O PACTO CONTENIDO EN ESTOS TÉRMINOS
                DE USO O DE CUALQUIER LEY O REGLAMENTO APLICABLE. PODEMOS TERMINAR SU USO O PARTICIPACIÓN EN EL SITIO O
                BORRAR SU CUENTA Y CUALQUIER CONTENIDO O INFORMACIÓN QUE USTED PUBLICÓ EN CUALQUIER MOMENTO, SIN
                ADVERTENCIA, A NUESTRA ÚNICA DISCRECIÓN.
            </p>
            <p style={{marginTop: 10}}>También nos reservamos el derecho de eliminar su cuenta y todos los datos
                almacenados en su cuenta sin notificación previa si no ha utilizado el Sitio para reservar un viaje en
                los últimos 12 meses. Si cancelamos o suspendemos su cuenta por cualquier motivo que no sea la
                inactividad, como se describe anteriormente, se le prohíbe registrarse y crear una nueva cuenta con su
                nombre, un nombre falso o prestado, o el nombre de un tercero, incluso si puede actuar en nombre del
                tercero. Además de cancelar o suspender su cuenta, nos reservamos el derecho de emprender las acciones
                legales apropiadas, incluidas, entre otras, la búsqueda de una reparación civil, penal y por mandato
                judicial. No seremos responsables ante usted o cualquier tercero por cualquier reclamo o daño que surja
                de cualquier terminación o suspensión o cualquier otra acción tomada por nosotros en relación con dicha
                terminación o suspensión.</p>

            <h3 style={{marginTop: 10}}>18. Modificaciones e interrupciones</h3>

            <p style={{marginTop: 10}}>
                Nos reservamos el derecho de cambiar, modificar o eliminar el contenido del Sitio en cualquier momento o
                por cualquier motivo a nuestro exclusivo criterio sin previo aviso. Sin embargo, no tenemos la
                obligación de actualizar ninguna información en nuestro sitio. También nos reservamos el derecho de
                modificar o descontinuar todo o parte del Sitio sin previo aviso en cualquier momento. No seremos
                responsables ante usted ni ante ningún tercero por ninguna modificación, cambio de precio, suspensión o
                interrupción del Sitio.
            </p>
            <p style={{marginTop: 10}}>
                No podemos garantizar que el sitio esté disponible en todo momento. Es posible que experimentemos
                hardware, software u otros problemas o que necesitemos realizar un mantenimiento relacionado con el
                Sitio, lo que resultará en interrupciones, retrasos o errores. Nos reservamos el derecho de cambiar,
                revisar, actualizar, suspender, descontinuar o modificar el Sitio en cualquier momento o por cualquier
                motivo sin previo aviso. Usted acepta que no tenemos responsabilidad alguna por cualquier pérdida, daño
                o inconveniente causado por su incapacidad para acceder o utilizar el Sitio durante cualquier tiempo de
                inactividad o interrupción del Sitio. Nada en estos Términos de uso se interpretará en el sentido de que
                nos obligue a mantener y respaldar el Sitio o proporcionar correcciones, actualizaciones o publicaciones
                en relación con el mismo
            </p>

            <h3 style={{marginTop: 10}}>19. Legislación aplicable y controversias</h3>

            <p style={{marginTop: 10}}>
                Estos Términos y condiciones de uso y cualquier obligación extracontractual que surja de ellos o en
                conexión con ellos se regirán e interpretarán de acuerdo con las leyes de Ecuador.
            </p>
            <p style={{marginTop: 10}}>
                Las disputas relacionadas con los derechos y / u obligaciones establecidos en los documentos del
                contrato deberán someterse de mediación conforme a la ley del país, mediación que se la realizará en los
                Centros existentes, en la ciudad de Quito, caso contrario podrán recurrir las partes en caso de
                divergencia a los jueces competentes de la ciudad de Quito.
            </p>

            <h3 style={{marginTop: 10}}>20. Correcciones</h3>

            <p style={{marginTop: 10}}>
                Puede haber información en el Sitio que contenga errores tipográficos, inexactitudes u omisiones que
                puedan estar relacionadas con el Sitio, incluidas descripciones, precios, disponibilidad y otra
                información diversa. Nos reservamos el derecho de corregir cualquier error, inexactitud u omisión y de
                cambiar o actualizar la información en el Sitio en cualquier momento, sin previo aviso.
            </p>

            <h3 style={{marginTop: 10}}>21. Descargo de responsabilidad</h3>

            <p style={{marginTop: 10}}>
                EL SITIO SE PROPORCIONA TAL COMO ESTÁ Y SEGÚN ESTÉ DISPONIBILIDAD. USTED ACEPTA QUE EL USO DE LOS
                SERVICIOS DEL SITIO SERÁ BAJO SU PROPIO RIESGO. HASTA EL GRADO MÁXIMO PERMITIDO POR LA LEY, NOSOTROS
                RECHAZAMOS TODAS LAS GARANTÍAS, EXPRESAS O IMPLÍCITAS, EN RELACIÓN CON EL SITIO Y SU USO DEL MISMO,
                INCLUYENDO, SIN LIMITACIÓN, LAS GARANTÍAS IMPLÍCITAS DE COMERCIABILIDAD, ADECUACIÓN PARA UN PROPÓSITO DE
                INFRACCIÓN PARTICULAR. NO OFRECEMOS GARANTÍAS NI DECLARACIONES SOBRE LA EXACTITUD O INTEGRIDAD DEL
                CONTENIDO DEL SITIO O EL CONTENIDO DE CUALQUIER SITIO WEB VINCULADO A ESTE SITIO Y NO ASUMIMOS NINGUNA
                RESPONSABILIDAD POR CUALQUIER (1) ERROR, ERROR O MATERIAL DE CONTENIDO INEXACTITUD ( 2) LESIONES
                PERSONALES O DAÑOS A LA PROPIEDAD, DE CUALQUIER NATURALEZA, QUE RESULTEN DE SU ACCESO Y USO DEL SITIO,
                (3) CUALQUIER ACCESO O USO NO AUTORIZADO DE NUESTROS SERVIDORES SEGUROS Y / O CUALQUIER Y TODA LA
                INFORMACIÓN PERSONAL Y / O INFORMACIÓN FINANCIERA ALMACENADO EN EL MISMO, (4) CUALQUIER INTERRUPCIÓN O
                CESE DE LA TRANSMISIÓN HACIA O DESDE EL SITIO, (5) CUALQUIER ERROR, VIRUS, CABALLO TROYANO, O LO QUE SE
                PUEDE TRANSMITIR AL SITIO O A TRAVÉS DEL SITIO POR CUALQUIER TERCERO, Y / O ( 6) CUALQUIER ERROR U
                OMISIÓN EN CUALQUIER CONTENIDO Y MATERIALES O POR CUALQUIER PÉRDIDA O DAÑO DE CUALQUIER TIPO INCURRIDO
                COMO RESULTADO DEL USO DE CUALQUIER CONTENIDO PUBLICADO, TRANSMITIDO O DISPONIBLE DE OTRO MODO A TRAVÉS
                DEL SITIO. NO GARANTIZAMOS, APROBAMOS, GARANTIZAMOS O ASUMIMOS RESPONSABILIDAD POR NINGÚN PRODUCTO O
                SERVICIO PUBLICITADO U OFRECIDO POR UN TERCERO A TRAVÉS DEL SITIO, CUALQUIER SITIO WEB HIPERVINCULADO O
                CUALQUIER SITIO WEB O APLICACIÓN MÓVIL QUE SE PRESENTA EN CUALQUIER BANNER U OTRA PUBLICIDAD, Y NOSOTROS
                NO SER UNA PARTE O DE ALGUNA MANERA SER RESPONSABLE DE MONITOREAR CUALQUIER TRANSACCIÓN ENTRE USTED Y
                CUALQUIER TERCERO PROVEEDOR DE PRODUCTOS O SERVICIOS. COMO CON LA COMPRA DE UN PRODUCTO O SERVICIO A
                TRAVÉS DE CUALQUIER MEDIO O EN CUALQUIER ENTORNO, DEBE USAR SU MEJOR JUICIO Y TENER PRECAUCIÓN DONDE SEA
                APROPIADO. ALGUNOS ESTADOS O JURISDICCIONES NO PERMITEN LA EXCLUSIÓN DE CIERTAS GARANTÍAS, POR LO QUE
                ALGUNAS DE LAS LIMITACIONES ANTERIORES PUEDEN NO APLICARSE EN SU CASO.
            </p>

            <h3 style={{marginTop: 10}}>22. Limitaciones de responsabilidad</h3>

            <p style={{marginTop: 10}}>
                EN NINGÚN CASO NOSOTROS O NUESTROS DIRECTORES, EMPLEADOS, AFILIADOS O AGENTES SEREMOS RESPONSABLES ANTE
                USTED O CUALQUIER TERCERO POR CUALQUIER DAÑO ESPECIAL, PUNITIVO, INCIDENTAL, INDIRECTO O CONSECUENTE DE
                NINGÚN TIPO, O CUALQUIER DAÑO DE NINGÚN TIPO, INCLUYENDO, SIN LIMITACIÓN, POR PÉRDIDA DE USO, DATOS O
                BENEFICIOS, YA SEA QUE HEMOS SIDO ADVERTIDOS DE LA POSIBILIDAD DE DICHOS DAÑOS, Y DE CUALQUIER TEORÍA DE
                RESPONSABILIDAD, QUE SURJA O EN RELACIÓN CON EL USO DE ESTE SITIO O DE CUALQUIER SITIO WEB REFERENCIADO
                O VINCULADO A DESDE ESTE SITIO.
            </p>
            <p style={{marginTop: 10}}>
                ADEMÁS, NO SEREMOS RESPONSABLES DE NINGÚN MODO POR LOS BIENES Y SERVICIOS DE TERCEROS OFRECIDOS A TRAVÉS
                DE ESTE SITIO O DE LA ASISTENCIA PARA REALIZAR TRANSACCIONES COMERCIALES A TRAVÉS DE ESTE SITIO,
                INCLUYENDO SIN LIMITACIÓN EL PROCESAMIENTO DE PEDIDOS.
            </p>
            <p style={{marginTop: 10}}>
                ADEMÁS, EL IKU NO SERÁ RESPONSABLE DE DAÑOS, PÉRDIDAS O LESIONES RESULTANTES DE (A) ACCESO NO AUTORIZADO
                A, HACKEAR O MANIPULACIÓN DE SU CUENTA O LA INFORMACIÓN EN EL MISMO, (B) ACCESO O USO NO AUTORIZADO DE
                LOS SERVIDORES PERSONALES DEL IKU Y CUALQUIER INFORMACIÓN ALMACENADA EN EL MISMO O (C) ERRORES, VIRUS,
                CABALLOS TROYANOS, MALWARE U OTRO CÓDIGO DESTRUCTIVO.
            </p>
            <p style={{marginTop: 10}}>
                USTED ACEPTA QUE EL USO DE LOS SERVICIOS ES BAJO SU PROPIO RIESGO. SI NO ESTÁ SATISFECHO CON LOS
                SERVICIOS, EL ÚNICO Y EXCLUSIVO REMEDIO ES TERMINAR SU USO DE LOS SERVICIOS.
            </p>

            <h3 style={{marginTop: 10}}>23. Indemnización</h3>

            <p style={{marginTop: 10}}>
                Usted acepta indemnizar, defender y eximir de responsabilidad a IKU, sus subsidiarias, agentes,
                otorgantes de licencias, gerentes, consultores, funcionarios, directores, empleados, contratistas,
                asesores, afiliados y socios (colectivamente "Afiliados") de y contra todas las reclamaciones y
                pérdidas. , responsabilidad, gastos, daños, sentencias, premios y costos (incluidos los honorarios
                razonables de abogados), relacionados con o derivados de (1) cualquier incumplimiento de estos Términos
                de uso, (2) el uso o mal uso de cualquier derecho de propiedad intelectual, material o información de
                propiedad, publicada, proporcionada, transmitida o puesta a su disposición por IKU, (3) su acceso o uso
                del Sitio y su contenido relacionado, (4) su violación de cualquier derecho de terceros, incluida la
                propiedad intelectual y derechos de privacidad, (5) su violación de una ley, regla o reglamento, (6) el
                uso del Sitio por parte de otra parte usando su cuenta, o (7) cualquier acto dañino manifiesto hacia
                cualquier otro usuario del Sitio con el que se conectó a través de el sitio.
            </p>
            <p style={{marginTop: 10}}>
                No obstante lo anterior, IKU se reserva el derecho de asumir la defensa y el control exclusivos de
                cualquier asunto que esté sujeto a indemnización en virtud de esta sección. En tal caso, acepta cooperar
                con cualquier solicitud razonable que ayude a IKU a defender dicho asunto.
            </p>

            <h3 style={{marginTop: 10}}>24. Datos de usuario</h3>

            <p style={{marginTop: 10}}>
                Conservaremos ciertos datos que transmita al Sitio con el fin de administrar el Sitio, así como los
                datos relacionados con su uso del Sitio. Aunque realizamos copias de seguridad de datos de forma
                periódica, usted es el único responsable de todos los datos que transmita o que se relacionen con
                cualquier actividad que haya realizado utilizando el Sitio. Usted acepta que no seremos responsables
                ante usted por cualquier pérdida o corrupción de dichos datos, y por la presente renuncia a cualquier
                derecho de acción contra nosotros que surja de dicha pérdida o corrupción de dichos datos.
            </p>

            <h3 style={{marginTop: 10}}>25. Comunicaciones, transacciones y firmas electrónica</h3>

            <p style={{marginTop: 10}}>
                Visitar el Sitio, enviarnos correos electrónicos y completar formularios en línea constituyen
                comunicaciones electrónicas. Usted da su consentimiento para recibir comunicaciones electrónicas y
                acepta que todos los acuerdos, avisos, divulgaciones y otras comunicaciones que le proporcionamos
                electrónicamente, por correo electrónico y en el Sitio, satisfacen cualquier requisito legal de que
                dicha comunicación sea por escrito. USTED ACEPTA EL USO DE FIRMAS, CONTRATOS, PEDIDOS Y OTROS REGISTROS
                ELECTRÓNICOS, Y LA ENTREGA ELECTRÓNICA DE AVISOS, POLÍTICAS Y REGISTROS DE TRANSACCIONES INICIADAS O
                COMPLETADAS POR NOSOTROS O A TRAVÉS DEL SITIO. Por la presente, usted renuncia a cualquier derecho o
                requisito bajo cualquier estatuto, reglamento, regla, ordenanza u otras leyes en cualquier jurisdicción
                que requieran una firma original o la entrega o retención de registros no electrónicos, o para pagos o
                la concesión de créditos por cualquier otro medio. que los medios electrónicos.
            </p>

            <h3 style={{marginTop: 10}}>26. Varios</h3>

            <p style={{marginTop: 10}}>
                Estos Términos de uso y cualquier política o regla operativa publicada por nosotros en el Sitio
                constituyen el acuerdo completo y el entendimiento entre usted y nosotros. El hecho de que no ejerzamos
                o hagamos cumplir cualquier derecho o disposición de estos Términos de uso no constituirá una renuncia a
                dicho derecho o disposición. Estos Términos de uso operan en la mayor medida permitida por la ley.
                Podemos ceder alguno o todos nuestros derechos y obligaciones a otros en cualquier momento. No seremos
                responsables por ninguna pérdida, daño, demora o falta de actuación causados por cualquier causa fuera
                de nuestro control razonable. Si alguna disposición o parte de una disposición de estos Términos de uso
                se determina que es ilegal, nula o inaplicable, esa disposición o parte de la disposición se considerará
                separable de estos Términos de uso y no afectará la validez y aplicabilidad de los restantes.
                provisiones. No existe una relación de empresa conjunta, sociedad, empleo o agencia creada entre usted y
                nosotros como resultado de estos Términos de uso o el uso del Sitio. Usted acepta que estos Términos de
                uso no se interpretarán en nuestra contra en virtud de haberlos redactado. Por la presente, renuncia a
                todas y cada una de las defensas que pueda tener basadas en la forma electrónica de estos Términos de
                uso y la falta de firma por parte de las partes para ejecutar estos Términos de uso. No puede ceder sus
                derechos y obligaciones en virtud de estos Términos de uso a ninguna parte, y cualquier intento de
                hacerlo será nulo y sin efecto.
            </p>
            <p style={{marginTop: 10}}>
                Usted acepta no vender, revender, reproducir, duplicar, copiar o utilizar con fines comerciales
                cualquier parte de este sitio, o el uso o acceso a este sitio.
            </p>
            <p style={{marginTop: 10}}>
                El uso de las funciones y el contenido de Google Maps en los Servicios está sujeto a las versiones
                actuales de los Términos de servicio adicionales de Google Maps / Google Earth en
                https://maps.google.com/help/terms_maps.html y la Política de privacidad de Google en
                https://www.google.com/policies/privacy .
            </p>

            <h3 style={{marginTop: 10}}>27. Contáctenos</h3>

            <p style={{marginTop: 10}}>
                Para resolver una queja relacionada con el Sitio o para recibir más información sobre el uso del Sitio,
                comuníquese con nosotros a través de nuestro formulario de contacto en nuestro sitio web
                www.KireiApps.com.
            </p>
            <p style={{marginTop: 10}}>
                Estos Términos se publicaron en el sitio web el 28-03-2021
            </p>
        </div>
    )
}


export default inject('SessionStore')(observer(Privacy));

